import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { recoverPetData, recoverPet } from '@/api/gmToolNew/gmToolNew';
export default {
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      dialogShow: false,
      tableCopyTableList: [],
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      paramsData: {
        player_id: "",
        pet_id: ""
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open() {
      this.tableCopyTableList = [];
      this.currentPage = 1;
      this.pageSize = 10;
      this.tableData = [];
      this.paramsData.player_id = "";
      this.paramsData.pet_id = "";
      this.dialogShow = true;
    },
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.paramsData.player_id) {
                  _context.next = 3;
                  break;
                }

                _this.$message.error(_this.$t('pleaseEnterRoleId'));

                return _context.abrupt("return");

              case 3:
                if (_this.paramsData.pet_id) {
                  _context.next = 6;
                  break;
                }

                _this.$message.error(_this.$t('pleaseEnterPetId'));

                return _context.abrupt("return");

              case 6:
                if (_this.paramsData.server_id) {
                  _context.next = 9;
                  break;
                }

                _this.$message.error(_this.$t('pleaseSelectServer'));

                return _context.abrupt("return");

              case 9:
                _this.reqLoading = true;
                params = {
                  env_id: _this.paramsData.env_id,
                  game_id: _this.rawData.game_id,
                  player_id: _this.paramsData.player_id,
                  pet_id: _this.paramsData.pet_id,
                  server_id: _this.paramsData.server_id
                };
                recoverPetData(params).then(function (res) {
                  if (res.status == 200) {
                    var data = JSON.parse(res.data);
                    data.forEach(function (item) {
                      item.talents = item.talents && JSON.parse(item.talents).join(",") || "";
                      item.skills = item.skills && JSON.parse(item.skills).join(",") || "";
                    });
                    _this.tableCopyTableList = JSON.parse(JSON.stringify(data));
                    _this.tableData = _this.currentChangePage(_this.pageSize, _this.currentPage);
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    reply: function reply(row) {
      var _this2 = this;

      if (this.paramsData.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.$confirm(this.$t('confirmRestore'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  env_id: _this2.paramsData.env_id,
                  game_id: _this2.rawData.game_id,
                  player_id: _this2.paramsData.player_id,
                  uid: row.uid,
                  server_id: _this2.paramsData.server_id
                };
                recoverPet(params).then(function (res) {
                  if (res.status == 200) {
                    _this2.$message.success(_this2.$t('restoreSuccess'));

                    _this2.dialogShow = false;

                    _this2.$emit('change');
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.tableData = this.currentChangePage(pageSize, this.currentPage);
    },
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.tableData = this.currentChangePage(this.pageSize, currentPage);
    },
    currentChangePage: function currentChangePage(size, current) {
      var tablePush = [];
      this.tableCopyTableList.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    }
  }
};